export const SYNC_PUSH_MAX = 200;
export const SYNC_PULL_DEFAULT = 500;
export const SYNC_PULL_MAX = 1000;
export const SYNC_TOMBSTONE_DAYS = 180;
/** Locked money fields on delivered/paid loads. */
export const LOCKED_MONEY_FIELDS = [
    "linehaulCents",
    "fscCentsPerMile",
    "accessorialsCents",
    "loadedMiles",
    "deadheadMiles",
    "payContractId",
];
/** Server-owned fields stripped from client patches. */
export const SERVER_ONLY_FIELDS = [
    "orgId",
    "version",
    "createdAt",
    "updatedAt",
    "fieldMeta",
    "settlementId",
    "paidAt",
    "bookedAt",
    "deliveredAt",
];
//# sourceMappingURL=protocol.js.map